export default {
  darkText: true,
  showAccentLine: true,
  opacity: 1,
  title: "Product Logins",
};
